export default __webpack_public_path__ + "static/media/culture_EP3.214def90.png";